/*--------------------------------------------------------------
# Custom scripts for Post feed block
--------------------------------------------------------------*/

const postFeedSlider = document.querySelectorAll('.post-feed-slider .swiper');
const postFeedSliderPagination = document.querySelectorAll('.post-feed-swiper-pagination');
const postFeedSliderNext = document.querySelectorAll('.post-feed-swiper-next');
const postFeedSliderPrev = document.querySelectorAll('.post-feed-swiper-prev');

for( i = 0; i < postFeedSlider.length; i++ ) {
    // loop through every example of the slider and add a dynamic class
    // then init slider, pagination and nav arrows based on that new dynamic class
    postFeedSlider[i].classList.add('swiper-' + i);
    postFeedSliderPagination[i].classList.add('post-feed-swiper-pagination-' + i);
    postFeedSliderNext[i].classList.add('post-feed-swiper-next-' + i);
    postFeedSliderPrev[i].classList.add('post-feed-swiper-prev-' + i);

    var initPostFeedSlider = new Swiper('.post-feed-slider .swiper-' + i, {
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 24,
        mousewheel: {
            enabled: true,
            releaseOnEdges: true,
            forceToAxis: true,
        },
        // Pagination toggle buttons
        pagination: {
            el: '.post-feed-swiper-pagination-' + i,
            clickable: true,
        },
        // Navigation arrows
        navigation: {
            nextEl: '.post-feed-swiper-next-' + i,
            prevEl: '.post-feed-swiper-prev-' + i,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            992: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            }
        }
    });
}
